export default "__VITE_ASSET__3k2BFdG6__"